import Highcharts from 'highcharts'
import produce from 'immer'
import { Recipe } from 'types/immer'

const COMMON_OPTIONS = {
  animation: false,
  marker: {
    enabled: false,
    symbol: 'circle',
    fillColor: null,
    lineColor: 'white',
    lineWidth: 2,
    radius: 4,
    states: {
      hover: {
        enabled: true
      }
    }
  },
  states: {
    hover: {
      halo: {
        size: 12
      }
    }
  }
}

const COMMON_AREA_SERIES_OPTIONS: Highcharts.SeriesAreaOptions = {
  ...COMMON_OPTIONS,
  type: 'area'
}

const COMMON_LINE_SERIES_OPTIONS: Highcharts.SeriesLineOptions = {
  ...COMMON_OPTIONS,
  type: 'line'
}

export const createAreaSeriesOptions = (recipe: Recipe<Highcharts.SeriesAreaOptions>) =>
  produce(COMMON_AREA_SERIES_OPTIONS, recipe)

export const createLineSeriesOptions = (recipe: Recipe<Highcharts.SeriesLineOptions>) =>
  produce(COMMON_LINE_SERIES_OPTIONS, recipe)
